/*
 * @Author: wangbaihe
 * @Date: 2024-01-08 11:02:56
 * @LastEditors: wangbaihe
 * @LastEditTime: 2025-11-18 15:18:57
 * @FilePath: \common-mediax\src\apis\MediaCloudPublishCenter\Web.js
 * @Description:
 */
import { createAPI } from '@common'
/* 网站拆分后的接口 MediaCloudPublishCenterWeb */
export default {
  // 文章是否包含图片
  postNewseditAttachmentsCheck: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0buubdinfout0difdl', 'post', config),
  // 送审
  postRootArticlesTransfer: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0usbotgfs', 'post', config),
  // 审核完成
  postArticlePass: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0qbtt', 'post', config),
  // 撤稿
  postArticleRevoke: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0sfwplf', 'post', config),
  // 驳回
  postArticleReject: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0sfkfdu', 'post', config),
  // 校核完成
  postArticleProof: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0qsppg', 'post', config),
  // 稿件置顶
  postArticlesSortingTop: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0tpsujoh0upq', 'post', config),
  // 发布
  postArticlesPublish: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0qvcmjti', 'post', config),
  // 签发稿件到报纸
  postPaperArticlesForward: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmfxfct0qbqfs0tjho0gpsxbse',
      'post',
      config,
      {
        timeout: 90000
      }
    ),
  // 签发稿件到全媒体采编发（发布用的也是这个接口
  postArticlesForward: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmfxfct0jttvf', 'post', config, {
      timeout: 90000
    }),
  // 固定位置设置
  postArticlesSortingPosition: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0tpsujoh0qptjujpo', 'post', config),
  // 保存关联接口
  putArtcilesColumnrel: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0dpmvnosfm', 'put', config),
  // 解除关联
  deleteArtcilesColumnrel: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0dpmvnosfm', 'delete', config),
  // 原稿会彻底删除，发布库稿件会设删除标记
  postArticleDelete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0efmfuf', 'post', config),
  // 移动
  putArtcilesMove: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0npwf', 'put', config, {
      timeout: 60000
    }),
  // 复制
  postArtcilesCopy: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmfxfct0dpqz', 'post', config, {
      timeout: 60000
    }),
  // 置顶,固定位置获取过期时间
  getArticlesSortingExpireTime: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0tpsujoh0fyqjsfUjnf', 'get', config),
  // 获取阅读数设置
  getArticleSetting: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0tfuujoh', 'GET', config),
  // 保存阅读数设置
  postArticleSetting: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0tfuujoh', 'POST', config),
  // 修改发布时间
  postArticlePubTime: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0qvcUjnf', 'POST', config),
  // 移动调序（跨页调序）========= 检查是否置顶或固定位置
  postArticleSortingCheckTopOrPosition: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0tpsujoh0difdlUpqPsQptjujpo',
      'POST',
      config
    ),
  // 移动调序（跨页调序）========= 移动调序接口
  postArticleSortingMove: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0tpsujoh0npwf', 'POST', config),

  // 流程记录
  getE5ActionsLogs: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0f60bdujpot0mpht', 'get', config, vconfig),

  // 读当前用户可访问的报纸列表（全媒体采编发提供的接口）
  getNewseditUserPapersNew: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0ofxtfeju0vtfst0qbqfst', 'get', config),
  // 读当前用户可访问的报纸的栏目列表（全媒体采编发提供的接口）
  getNewseditUserPapersColumnsNew: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0ofxtfeju0vtfst0qbqfst0dpmvnot',
      'get',
      config
    ),
  // 给定一个栏目，读出版面列表（全媒体采编发提供的接口）
  getNewseditUserPapersLayoutsNew: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0ofxtfeju0vtfst0qbqfst0mbzpvut',
      'get',
      config
    ),
  // 获取拥有图片制作人员的名单（全媒体采编发提供的接口）
  getNewseditPicmakeUsersNew: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0ofxtfeju0qjdnblf0vtfst', 'get', config, {
      neverLoading: true
    }),
  // 签发稿件到全媒体采编发（全媒体采编发提供的接口）
  postNewseditArticlesForwardNew: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0ofxtfeju0bsujdmft0gpsxbse', 'post', config),
  // 修改痕迹 - 所有
  getAllArticlesTraces: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0wfstjpo0usbdf0bmm', 'get', config),
  // 获取不同用户修改痕迹
  getArticlesTracesByDifUserNew: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0wfstjpo0usbdf0vtfst0bmufsobuf',
      'get',
      config,
      vconfig
    ),
  // 根据指定用户获取修改痕迹 - 未使用
  getArticlesTracesBySameUser: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0wfstjpo0usbdf0vtfst0tbnf', 'get', config),
  // 根据选择版本获取修改痕迹
  getArticlesTracesByVersion: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0wfstjpo0usbdf0wfstjpot0tfmfdu',
      'get',
      config,
      vconfig
    ),
  // 还原已删除稿件
  postArticleRevert: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0bsujdmfSfwfsu',
      'post',
      config,
      vconfig
    ),
  ///articles/dealArticleAttr
  postArticleDealArticleAttr: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0efbmBsujdmfBuus',
      'post',
      config,
      vconfig
    ),
  getArticleDealArticleAttr: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0hfuBuus', 'get', config, vconfig),
  // 彻底删除已删除稿件
  postArticleDeleteReal: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0efmfufSfbm',
      'post',
      config,
      vconfig
    ),
  // 判断是否有回收站权限
  getRecycleRoot: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnot0sppuEfmfuf', 'get', config),
  // web详情页获取有权限的操作按钮列表
  getArticlesActions: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0f60bdujpot0efubjmbdujpot', 'get', config),
  // 查看权限消息
  getDetailStatus: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0efubjm0tubuvt', 'get', config),

  /* ********************************下面是确定拆分后网站稿件独有********************************** */

  // 网站发布-稿件详情
  getArticlesDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmfxfct0efubjm', 'get', config),
  // 稿件详情(统一用)
  getArticlesDetails: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmfxfct0efubjm', 'get', config),
  // 网站发布-写稿初始化
  getInit: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmfxfct0joju', 'get', config),
  // 网站发布-写稿保存
  postSave: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmfxfct0dsfbuf', 'post', config, {
      ...vconfig,
      isSimpleSecurity: true
    }),

  // 网站发布-保存多标题稿件
  postCreateMrTitles: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmfxfct0dsfbufNsUjumft', 'post', config, {
      ...vconfig,
      isSimpleSecurity: true
    }),
  // 网站发布-查询多标题稿件
  initCreateMrTitles: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmfxfct0jojuNsUjumft', 'get', config),
  // 批量添加网站栏目
  postColumnwebsAddBatch: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnoxfct0beeCbudi', 'post', config),
  /* ********************************上面是确定拆分后网站稿件独有********************************** */
  // 发布栏目树拖动排序
  postNewColumnsDrag: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnoxfct0esbh', 'post', config),
  preAction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0f60bdujpot0qsfbdujpo', 'post', config, {
      neverLoading: true
    }),
  postAction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0f60bdujpot0qptubdujpo', 'get', config, {
      neverLoading: true
    }),
  //获取撤稿中心稿件类型
  getRevokeConditions: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0f60dpoejujpot', 'get', config),
  //获取撤稿中心列表
  getRevokeListdata: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0sfwplf0dfoufs0ofxMjtu',
      'POST',
      config
    ),
  postArticle4Delete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0efmfuf5Dpmvnot', 'post', config)
}
